export const COLS = 120;
export const ROW_HEIGHT = 3;
export const GRID_MARGIN = [1, 1];
export const GRID_WIDTH_PORTRAIT = 120;
export const GRID_HEIGHT = 240;
export const GRID_WIDTH_LANDSCAPE = 57.5;
